"use strict";
import { Percent } from "@uniswap/sdk-core";
const PRECISION = 1e4;
const DENOMINATOR = PRECISION * 100;
export function toSlippagePercent(slippage) {
  const numerator = Math.floor(Number(slippage) * PRECISION);
  return new Percent(numerator, DENOMINATOR);
}
